import Tag from '.';

/** @type {UICore.ComponentMeta} */
const TagComponentMeta = {
  id: 'w-tag',
  name: '标签',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-tag_1636365441213.png',
  category: '展示',
  display: 'inline',
  component: Tag,
  bindings: [{
    id: '标签内容',
    prop: 'text'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'text',
      type: 'string',
      title: '内容',
      default: '',
      description: '**undefined null 空数组 空字符串** 无效'
    }, {
      id: 'type',
      type: 'string',
      title: '主题',
      enum: [{
        label: '基本',
        value: 'normal'
      }, {
        label: '主要',
        value: 'primary'
      }, {
        label: '危险',
        value: 'danger'
      }, {
        label: '警告',
        value: 'warning'
      }, {
        label: '成功',
        value: 'success'
      }, {
        label: '自定义',
        value: 'custom'
      }],
      description: '预设和自定义主题使用不同样式'
    }, {
      id: 'color',
      type: 'string',
      title: '自定义颜色',
      default: '#0F8EE9',
      ui: {
        type: 'colorPicker'
      },
      condition: 'props.type === "custom"'
    }, {
      id: 'icon',
      type: 'string',
      title: '图标',
      default: '',
      ui: {
        type: 'iconSelectorInput'
      }
    }]
  },
  events: [{
    id: 'click',
    name: '点击',
    asProp: 'handleClick',
    arguments: [{
      type: 'string',
      description: '标签内容'
    }, {
      type: 'any',
      description: '原生点击事件'
    }]
  }]
};
export default TagComponentMeta;